import { ApiResponse, post } from '@commblades/commblades';

import { YourFinanceResponse, YourFinanceSubmit } from './yourFinanceTypes';

const submitYourFinanceApi = (
    url: string,
    payload: YourFinanceSubmit,
): Promise<ApiResponse<YourFinanceResponse>> => post({ url, payload });

export default submitYourFinanceApi;
